// Lib
import { asObject, prop } from '../../../../common/utils/immutableHelper';
import { getTableCellSearchValue } from '../../../element/table/bridge/tableSearchRuntime';

const EMPTY_ARRAY = [];

const getDraftBlockText = (draftBlock) => prop('text', draftBlock) || '';
const getDraftBlocks = (draftContent) => prop('blocks', draftContent) || EMPTY_ARRAY;

export const draftContentHasMatch = (queryRegEx) => (draftContent) => {
    if (!draftContent || typeof draftContent !== 'object') return false;
    return getDraftBlocks(draftContent).some((block) => !!getDraftBlockText(block).match(queryRegEx));
};

export const tableContentHasMatch =
    (queryRegEx, locale) =>
    (_elementId, tableData) => {
        if (!tableData) return false;

        return asObject(tableData)?.some((row, rowIndex) =>
            row?.some((cell, colIndex) => String(getTableCellSearchValue(cell, locale))?.match(queryRegEx)),
        );
    };

export const stringMatches = (queryRegEx) => (string) => string && !!string.match(queryRegEx);

export const stringMatchesProp = (propFn) => (queryRegex) => (element) => {
    const str = propFn(element);
    return stringMatches(queryRegex)(str);
};
